import { Component, OnInit } from '@angular/core';
import {Router} from "@angular/router";
import {environment} from "../../environments/environment";



@Component({
  selector: 'app-appversion',
  templateUrl: './appversion.component.html',
  styleUrls: ['./appversion.component.css']
})
export class AppversionComponent {
  public version: string = "V1.4.21";
  public authEnabled: boolean = true;

  constructor(private router: Router) {
    this.authEnabled = environment.production;
  }

  forceReload() {
    if(confirm("New version available. Load New Version?")) {
      window.location.reload();
    }
  }


}

